/* Prototipo para columnas */
export interface PrototipoColumna {
  slug: string;
  descripcion: string;
  palabras: string[];
  matchExacto?: boolean; // Si es true, la columna debe coincidir exactamente con el nombre de la columna
  requerida: boolean;
  validador?: (valor: string) => string | null; // Regresa un mensaje de error si hay un error, null si todo está bien
}

/* Estado de fila orden */
export enum EstadoFilaOrden {
  INVALIDA = 'invalida',
  SIN_FORMATEAR = 'sin-formatear',
  FORMATEADA = 'formateada',
  SUBIDA = 'subida',
  FALLIDA = 'fallida',
}

/* Resultado de la subida de un archivo */
export interface ResultadoSubida {
  exitosos: number;
  fallidos: number;
  total: number;
}
